export default __webpack_public_path__ + "static/media/solution-tpan.f4976369.jpg";